import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentGatewaysPage } from './payment-gateways.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentGatewaysPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class PaymentGatewaysPageRoutingModule {}
